import { render, staticRenderFns } from "./projects-layout.vue?vue&type=template&id=3ac4fdb9&"
import script from "./projects-layout.vue?vue&type=script&lang=js&"
export * from "./projects-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* nuxt-component-imports */
installComponents(component, {ReportStatusWatcher: require('/lasso/components/reports/ReportStatusWatcher.vue').default,RfiImportStatusWatcher: require('/lasso/components/templates/RfiImportStatusWatcher.vue').default,QuickStartModal: require('/lasso/components/support/QuickStartModal.vue').default,NavMobile: require('/lasso/components/NavMobile.vue').default,Header: require('/lasso/components/Header.vue').default,Error: require('/lasso/components/Error.vue').default,PageHeader: require('/lasso/components/PageHeader.vue').default,ProjectsHeader: require('/lasso/components/projects/ProjectsHeader.vue').default,Breadcrumb: require('/lasso/components/Breadcrumb.vue').default,NavSecondary: require('/lasso/components/NavSecondary.vue').default,NavProjectMobile: require('/lasso/components/NavProjectMobile.vue').default,Footer: require('/lasso/components/Footer.vue').default,AssistantBubble: require('/lasso/components/AssistantBubble.vue').default})


/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ac4fdb9')) {
      api.createRecord('3ac4fdb9', component.options)
    } else {
      api.reload('3ac4fdb9', component.options)
    }
    module.hot.accept("./projects-layout.vue?vue&type=template&id=3ac4fdb9&", function () {
      api.rerender('3ac4fdb9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "layouts/projects-layout.vue"
export default component.exports